export default __webpack_public_path__ + "static/media/vehicle-tracking.02029d38.jpeg";